import { useToast } from '@app/core/notifications';
import { AuditLiveMentionConfidence } from '@mi-front/core';
import { Spinner } from '@mi-front/ui';
import { IconButton, Tooltip } from '@mui/material';
import { ThumbDown as ThumbDownIcon, ThumbUp as ThumbUpIcon } from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAuditLiveMention } from '../../../../../../../../audit/hooks/useAuditLiveMention';

export function LiveMentionConfidenceControls({
  stationId,
  id,
  className,
}: {
  stationId: string;
  id: string;
  className?: string;
}) {
  const { $t } = useIntl();
  const { notifyInfo } = useToast();
  const { data, isLoading, confidenceMutation } = useAuditLiveMention(stationId, id);

  if (isLoading || !data) {
    return (
      <div className={className}>
        <Spinner />
      </div>
    );
  }

  if (data.confidence === AuditLiveMentionConfidence.REJECTED) {
    return null;
  }

  const onAccept = () => {
    confidenceMutation.mutate(
      data.confidence === AuditLiveMentionConfidence.ACCEPTED
        ? AuditLiveMentionConfidence.AUTO
        : AuditLiveMentionConfidence.ACCEPTED,
    );
  };

  const onReject = () => {
    if (
      !window.confirm(
        $t({
          id: 'audit.liveMentions.rejectConfirm',
          defaultMessage:
            '¿Confirma rechazar mention? En tal caso, se eliminará y se reprocesará en búsqueda de mejores resultados.',
        }),
      )
    ) {
      return;
    }

    confidenceMutation.mutate(AuditLiveMentionConfidence.REJECTED);

    notifyInfo(
      $t({
        id: 'audit.liveMentions.rejected',
        defaultMessage: 'Rechazada',
      }),
    );
  };

  return (
    <div className={className}>
      <Tooltip
        title={
          <FormattedMessage
            id="audit.liveMentions.acceptMention"
            defaultMessage="Aceptar mention"
          />
        }
      >
        <IconButton
          aria-label={$t({
            id: 'audit.liveMentions.acceptMention',
            defaultMessage: 'Aceptar mention',
          })}
          size="small"
          color={data.confidence === AuditLiveMentionConfidence.ACCEPTED ? 'success' : 'primary'}
          className="mt-1 ml-1"
          onClick={onAccept}
        >
          <ThumbUpIcon />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={
          <FormattedMessage
            id="audit.liveMentions.rejectMention"
            defaultMessage="Rechazar mention"
          />
        }
      >
        <IconButton
          aria-label={$t({
            id: 'audit.liveMentions.rejectMention',
            defaultMessage: 'Rechazar mention',
          })}
          size="small"
          color="primary"
          className="mt-1 ml-1"
          onClick={onReject}
        >
          <ThumbDownIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}
